import { Mapper } from "../../../../base/utils/mapper";
import { TeleconsultaInterestInsertModel } from "../../../../domain/models/comercial/teleconsulta-interest-insert.model";
import { TeleconsultaInterestInsertEntity } from "../entities/teleconsulta-interest-insert.entity";

export class TeleconsultaInterestInsertImplementationRepositoryMapper extends Mapper<TeleconsultaInterestInsertEntity, TeleconsultaInterestInsertModel> {
    mapFrom(param: TeleconsultaInterestInsertEntity): TeleconsultaInterestInsertModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message
        };
    }
    mapTo(param: TeleconsultaInterestInsertModel): TeleconsultaInterestInsertEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message
        }
    }
}
